import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  Directive,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'fz-chip',
  standalone: true,
  imports: [MatIcon, MatIconButton],
  templateUrl: './chip.html',
  styleUrls: ['./chip.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  hostDirectives: [
    {
      directive: MatTooltip,
      inputs: ['matTooltip'],
    },
  ],
  host: {
    class: 'fz-chip',
    '[class.fz-chip--highlighted]': 'highlighted',
  },
})
export class FzChip {
  @Input() image?: string;
  @Input({ required: true }) label: string;
  @Input({ transform: booleanAttribute }) highlighted?: boolean;
  @Input() tooltip?: string;
  @Input({ transform: booleanAttribute }) removable?: boolean;
  @Output() remove = new EventEmitter<void>();

  handleRemove() {
    this.remove.emit();
  }
}

@Directive({
  selector: 'fz-chip-label',
  host: {
    class: 'mat-chip-label',
  },
})
export class ChipLabel {}

@Directive({
  selector: 'fz-chip-image',
  host: {
    class: 'mat-chip-image',
  },
})
export class ChipImage {}

@Directive({
  selector: 'fz-chip-remove',
  host: {
    class: 'mat-chip-remove',
  },
})
export class ChipRemove {}
